module.exports = __webpack_public_path__ + "static/media/17_portrait.7b69ef08.jpg";